// extracted by mini-css-extract-plugin
module.exports = {"input":"SliderNumberInput_input__eFivp","unitText":"SliderNumberInput_unitText__hNQ7l"};